import styles from './ToolCodeBlock.module.css'
import {type PropsWithChildren, useState, useEffect} from 'react'

export interface ToolCodeBlockProps {
  language?: string
  shellLoading?: boolean
  code: string
  startOffset: number
  endOffset: number
}

export function ToolCodeBlock({shellLoading, children}: PropsWithChildren<ToolCodeBlockProps>) {
  const [loaderChar, setLoaderChar] = useState('|')

  useEffect(() => {
    let intervalId: NodeJS.Timeout | undefined
    if (shellLoading) {
      const loaderChars = ['|', '/', '-', '\\']
      let currentCharIndex = 0
      intervalId = setInterval(() => {
        currentCharIndex = (currentCharIndex + 1) % loaderChars.length
        setLoaderChar(loaderChars[currentCharIndex] || '|')
      }, 250)
    } else {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setLoaderChar('|') // Reset loader char when not loading
    }
    return () => clearInterval(intervalId)
  }, [shellLoading])

  return (
    <figure className={styles.container}>
      <div className={styles.codeContainer}>
        {/* Not focusable: the code wraps (see .codeWrap) inside a clipping container, so there is no scrollable overflow to reach by keyboard. */}
        <pre className={styles.code}>
          <code className={styles.codeWrap}>
            {children}
            {shellLoading && <span>{loaderChar}</span>}
          </code>
        </pre>
      </div>
    </figure>
  )
}
